<template>
  <div>
    <b-card class="mb-2" no-body>
      <b-card-header>
        <b-row align-v="center">
          <b-col cols="auto" class="mr-auto">
            <h5 class="">Внешние контакты</h5>
          </b-col>
          <b-col cols="auto">
            <b-button size="sm" v-if="canEditLocations()" variant="success" @click.stop="onAdd(false)" :disabled="isDisabled">
              <font-awesome-icon icon="plus" class="mr-1"/>
              Добавить
            </b-button>
            <b-button size="sm" variant="light" @click="isExternalExpanded = !isExternalExpanded">
              <font-awesome-icon :icon="isExternalExpanded ? 'chevron-up' : 'chevron-down'"/>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>

      <b-collapse v-model="isExternalExpanded">
        <b-table
          id="location-contacts"
          ref="location_contats"
          class="mb-0"
          striped
          small
          thead-class="top-fixed-thead thead-light"
          table-class="text-small"
          responsive
          show-empty
          :busy.sync="isBusy"
          :items="externalItems"
          :fields="fields"
          :current-page="externalCurrentPage"
          :per-page="perPage"
          :empty-text="$t('message.common.emptyTable')"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"/>
              <strong>Загрузка</strong>
            </div>
          </template>
          <template #cell(name)="row">
            <b-form-input
              id="input_name"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.name"
            />
          </template>

          <template #cell(job_title)="row">
            <b-form-input
              id="input_job_title"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.job_title"
            />
          </template>

          <template #cell(phone_number)="row">
            <b-form-input
              id="input_phone_number"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.phone_number"
            />
          </template>

          <template #cell(email)="row">
            <b-form-input
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.email"
            />
          </template>

          <template #cell(comment)="row">
            <b-form-input
              id="input_comment"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.note"
            />
          </template>

          <template #cell(action)="row">
            <b-button
              variant="danger"
              size="sm"
              :disabled="isDisabled"
              @click="onRemove(row)"
            >
              <font-awesome-icon icon="trash"/>
            </b-button>
          </template>
        </b-table>
        <b-card-footer footer-bg-variant="light">
          <b-row align-h="between" align-v="center">
            <b-col cols="auto" class="mr-auto">
              Всего записей: <b>{{externalItems.length}}</b>
            </b-col>
            <b-col cols="auto">
              <b-pagination
                id="location-contacts-pagination"
                pills
                :total-rows="externalItems.length"
                :per-page="perPage"
                v-model="externalCurrentPage"
              />
            </b-col>
          </b-row>
        </b-card-footer>
      </b-collapse>
    </b-card>

    <b-card no-body>
      <b-card-header>
        <b-row align-v="center">
          <b-col cols="auto" class="mr-auto">
            <h5 class="mb-0">Внутренние контакты</h5>
          </b-col>
          <b-col cols="auto">
            <b-button size="sm" v-if="canEditLocations()" variant="success" class="mr-2" @click.stop="onAdd(true)" :disabled="isDisabled">
              <font-awesome-icon icon="plus" class="mr-1"/>
              Добавить
            </b-button>
            <b-button size="sm" variant="light" @click="isInternalExpanded = !isInternalExpanded">
              <font-awesome-icon :icon="isInternalExpanded ? 'chevron-up' : 'chevron-down'"/>
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-collapse v-model="isInternalExpanded">
        <b-table
          id="location-contacts"
          class="mb-0"
          striped
          small
          thead-class="top-fixed-thead thead-light"
          table-class="text-small"
          responsive
          show-empty
          :busy.sync="isBusy"
          :items="internalItems"
          :fields="fields"
          :current-page="internalCurrentPage"
          :per-page="perPage"
          :empty-text="$t('message.common.emptyTable')"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"/>
            </div>
          </template>

          <template #cell(name)="row">
            <b-form-input
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.name"
            />
          </template>
          <template #cell(job_title)="row">
            <b-form-input
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.job_title"
            />
          </template>
          <template #cell(phone_number)="row">
            <b-form-input
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.phone_number"
            />
          </template>
          <template #cell(email)="row">
            <b-form-input
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.email"
            />
          </template>
          <template #cell(comment)="row">
            <b-form-input
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              v-model="row.item.note"
            />
          </template>
          <template #cell(action)="row">
            <b-button
              variant="danger"
              size="sm"
              :disabled="isDisabled"
              @click="onRemove(row, true)"
            >
              <font-awesome-icon icon="trash"/>
            </b-button>
          </template>
        </b-table>
        <b-card-footer footer-bg-variant="light">
          <b-row align-h="between" align-v="center">
            <b-col cols="auto" class="mr-auto">
              Всего записей: <b>{{internalItems.length}}</b>
            </b-col>
            <b-col cols="auto">
              <b-pagination
                id="location-contacts-pagination"
                pills
                :total-rows="internalItems.length"
                :per-page="perPage"
                v-model="internalCurrentPage"
              />
            </b-col>
          </b-row>
        </b-card-footer>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import helpers from "../../utilites/helpers";
  import permissions, {PERM} from "../../utilites/permissions";

export default {
  name: "LocationContacts",
  mixins: [
    locations,
    helpers, permissions
  ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      externalItems: [],
      internalItems: [],
      perPage: 10,
      externalCurrentPage: 1,
      internalCurrentPage: 1,
      fields: [
        {
          key: 'name',
          label: 'ФИО',
        },
        {
          key: 'job_title',
          label: 'Должность',
        },
        {
          key: 'phone_number',
          label: 'Телефон',
        },
        {
          key: 'email',
          label: 'Email'
        },
        {
          key: 'comment',
          label: 'Комментарий',
        },
        {
          key: 'action',
          label: "Действия",
          class: 'locationContactsAction',
          tdClass: 'align-bottom'
        },
      ],
      isExternalExpanded: true,
      isInternalExpanded: true,
    }
  },
  methods: {
    configure(locationId) {
      this.locationId = locationId;
      this.getItems();
    },
    async getItems() {
      this.isBusy = true;
      const result = await this.getLocationContactsById(this.locationId);
      this.isBusy = false;

      if (result.data == null) return;

      this.externalItems = result.data.items.filter(item => !item.is_internal);
      this.internalItems = result.data.items.filter(item => item.is_internal);
    },
    onAdd(isInternal) {
      const data = {
        id: 0,
        name: '',
        job_title: '',
        phone_number: '',
        email: '',
        note: '',
        is_internal: isInternal
      };

      if (isInternal) {
        this.internalItems.push(data);
        if (!this.isInternalExpanded) this.isInternalExpanded = true;
      } else {
        this.externalItems.push(data);
        if (!this.isExternalExpanded) this.isExternalExpanded = true;
      }
    },
    onRemove(row, isInternal) {
      if (row.item) {
        this.deleteRow = row.item;
      }

      const title = "Удаление контакта";
      const message = `Вы уверены, что хотите удалить контакт ${this.deleteRow.name || 'без имени'}?`;
      this.showModalDelete(title, message,() => {
        const currentPage = isInternal ? this.internalCurrentPage : this.externalCurrentPage;
        const index = ((currentPage  - 1) * this.perPage) + row.index;

        if (isInternal) {
          this.internalItems.splice(index, 1);
        } else {
          this.externalItems.splice(index, 1);
        }
      });
    },
    async saveContacts(locationId) {
      const allContacts = [...this.externalItems, ...this.internalItems];
      return await this.postLocationContacts(allContacts, locationId);
    },
    // Permissions
    canEditLocations() {
      return this.hasPermission([PERM.LOCATION_EDIT]);
    },
  }
}
</script>

<style>
.locationContactsAction {
  width: 80px;
}

#location-contacts td {
  text-align: center;
}

#location-contacts th {
  text-align: center;
  vertical-align: middle;
}

#location-contacts-pagination {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationContacts.vue